import React from "react";

import { IntroContainer, Paragraph, Mailtag, IntroImage } from "../styled-components/introstyle"

const Intro = () => {
  return (
    <IntroContainer>
        <Paragraph> Hi! I am a curator and producer living in Stockholm, Sweden.
        I have many years of experience in project management and coordination within the art world, and a big interest in front end development. </Paragraph>
        <Mailtag href="mailto:sofiaringstedt@gmail.com">Send me an email!</Mailtag>
          <IntroImage></IntroImage>
    </IntroContainer>
  )
}

export default Intro;